import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'filterItems'
})
export class FilterPipe implements PipeTransform {

    transform(items: any[], filter: string): any {

        if (!items || !filter) {
            return items
        }

        return items.filter(item => 
           
            //item.display.toLowerCase().indexOf(filter.toLowerCase()) !== -1

                            item.display.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || 
                            ( item.subdescr ? item.subdescr.toLowerCase().indexOf(filter.toLowerCase()) !== -1 : false)
            
            /*
            if (item.subdescr) {
                item.display.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.subdescr.toLowerCase().indexOf(filter.toLowerCase()) !== -1
            } else {
                item.display.toLowerCase().indexOf(filter.toLowerCase()) !== -1
            }
            */
            
        )

    }

}
